<div class="fast-quote-dialog">
    <form class="quote-tab" [formGroup]="quoteFG" (ngSubmit)="quoteFG.valid && quote()" *ngIf="!quoteResult">
        <span class="dialog-title">
            Cotización rápida
        </span>
        <span class="dialog-description">
            Complete los datos de la propiedad para realizar una cotización rápida, las garantías y administraciones de alquiler solo se pueden comenzar de una cotización normal.
        </span>
        <div class="horizontal-layout">
            <div class="tipo-propiedad-block">
                <span class="subsection-title">
                    Datos de la propiedad
                </span>
                <mat-radio-group class="form-radio-line" formControlName="tipo" color="primary">
                    <span class="radio-line-label">
                        Tipo de propiedad
                    </span>
                    <div class="radios">
                        <mat-radio-button *ngFor="let type of quoteTypes" [value]="type.codigo">{{ type.descripcion }}</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div>
            <div class="services-selector">
                <span class="subsection-title">
                    Servicios incluidos
                </span>
                <div class="bond-services" *ngIf="selectedServices.length">
                    <span class="service-chip" *ngFor="let service of selectedServices">{{ service.nombre }}</span>
                </div>
                <span class="fianza-placeholder" *ngIf="!selectedServices.length">
                    Seleccione un producto para ver los servicios incluidos.
                </span>
            </div>
        </div>
        <div class="property-settings">
                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="user.tipo === 'CORPORATIVO' && offices">
                        <mat-label>Oficina</mat-label>
                        <mat-select formControlName="oficina">
                            <mat-option *ngFor="let office of offices" [value]="office">
                                {{ office.nombre }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="quoteFG.controls['oficina'].hasError('required')">
                            Por favor seleccione una oficina
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="comerciales.length">
                        <mat-label>Comercial</mat-label>
                        <mat-select formControlName="idComercial">
                            <mat-option [value]="null">Sin asignar</mat-option>
                            <mat-option *ngFor="let comercial of comerciales" [value]="comercial.id">
                                {{ comercial.nombre }} {{ comercial.apellido }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Zona / Agrupación</mat-label>
                        <mat-select formControlName="idZona" (selectionChange)="onZonaChange($event.value)">
                            <mat-option [value]="null">Sin zona (Default)</mat-option>
                            <mat-option *ngFor="let zona of zonas" [value]="zona.id">{{ zona.nombre }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Producto / Fianza</mat-label>
                        <mat-select formControlName="idTipoFianza" (selectionChange)="onFianzaChange($event.value)">
                            <mat-option *ngFor="let fianza of tiposFianza" [value]="fianza.id">{{ fianza.nombre }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="quoteFG.controls['idTipoFianza'].hasError('required')">
                            Por favor seleccione un producto
                        </mat-error>
                    </mat-form-field>
                </div>
                <mat-form-field class="garantor-form-field full-width-field" appearance="outline" *ngIf="tiposDescuentoFiltrados.length">
                    <mat-label>Tipo de descuento</mat-label>
                    <mat-select formControlName="idTipoDescuento" (selectionChange)="onTipoDescuentoChange($event.value)">
                        <mat-option *ngFor="let td of tiposDescuentoFiltrados" [value]="td.id">
                            {{ td.nombre }}
                            <span>&nbsp;(tope {{ td.tope }}%)</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="garantor-form-field full-width-field" appearance="outline" *ngIf="mostrarPorcentajeRenovacion">
                    <mat-label>% Descuento</mat-label>
                    <input matInput formControlName="porcentajeRenovacion" type="number" style="text-align: right;">
                    <span matSuffix>&nbsp; %</span>
                    <mat-hint *ngIf="selectedTipoDescuento?.tope">
                        Máximo {{ selectedTipoDescuento.tope }}%
                    </mat-hint>
                    <mat-error *ngIf="quoteFG.controls['porcentajeRenovacion'].hasError('required')">
                        Por favor ingrese el porcentaje de descuento
                    </mat-error>
                    <mat-error *ngIf="quoteFG.controls['porcentajeRenovacion'].hasError('max')">
                        El tope máximo es {{ selectedTipoDescuento?.tope }}%
                    </mat-error>
                </mat-form-field>
                <div class="vivienda">
                    <div class="form-line">
                        <mat-form-field class="garantor-form-field" appearance="outline">
                            <mat-label>Moneda</mat-label>
                            <mat-select formControlName="monedaAlquiler" [compareWith]="compare">
                                <mat-option *ngFor="let currency of currencyValuesAvailable" [value]="currency.codigo">
                                    {{ currency.codigo }}
                                </mat-option>
                            </mat-select>
                            <!-- <input matInput formControlName="alquiler" type="number"> -->
                            <!-- <span matPrefix>$ &nbsp;</span> -->
                            <!-- <mat-error *ngIf="quoteFG.controls['alquiler'].hasError('required')">
                                Por favor ingrese el alquiler
                            </mat-error> -->
                        </mat-form-field>
                        <mat-form-field class="garantor-form-field" appearance="outline">
                            <mat-label>Alquiler</mat-label>
                            <input matInput formControlName="alquiler" type="number">
                            <span matPrefix>$ &nbsp;</span>
                            <mat-error *ngIf="quoteFG.controls['alquiler'].hasError('required')">
                                Por favor ingrese el alquiler
                            </mat-error>
                        </mat-form-field>

                    </div>

                    <div class="form-line">
                        <mat-form-field class="garantor-form-field" appearance="outline">
                            <mat-label>Moneda</mat-label>
                            <mat-select formControlName="monedaExpensas" [compareWith]="compare">
                                <mat-option *ngFor="let currency of currencyValuesAvailable" [value]="currency.codigo">
                                    {{ currency.codigo }}
                                </mat-option>
                            </mat-select>
                            <!-- <input matInput formControlName="alquiler" type="number"> -->
                            <!-- <span matPrefix>$ &nbsp;</span> -->
                            <!-- <mat-error *ngIf="quoteFG.controls['alquiler'].hasError('required')">
                                Por favor ingrese el alquiler
                            </mat-error> -->
                        </mat-form-field>

                        <mat-form-field class="garantor-form-field" appearance="outline">
                            <mat-label>Expensas</mat-label>
                            <input matInput formControlName="expensas" type="number">
                            <span matPrefix>$ &nbsp;</span>
                            <mat-error *ngIf="quoteFG.controls['expensas'].hasError('required')">
                                Por favor ingrese las expensas
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Tipo de cambio [full width, solo si moneda alquiler o expensas = USD] -->
                <mat-form-field class="garantor-form-field full-width-field" appearance="outline" *ngIf="mostrarTipoCambio">
                    <mat-label>Tipo de cambio</mat-label>
                    <input matInput formControlName="tipoCambio" type="number">
                    <span matPrefix>$ &nbsp;</span>
                    <mat-hint>Valor de referencia ARS por USD</mat-hint>
                </mat-form-field>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Tipo de actualización</mat-label>
                        <mat-select formControlName="tipoActualizacion">
                            <mat-option *ngFor="let op of tipoActualizacionOptions" [value]="op.codigo">
                                {{ op.descripcion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="mostrarInputCustom">
                        <mat-label>Especificar actualización</mat-label>
                        <input matInput formControlName="tipoActualizacionCustom" placeholder="Ej: CVS, otro índice...">
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="!mostrarInputCustom">
                        <mat-label>Porcentaje de actualización</mat-label>
                        <input matInput formControlName="actualizacion" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp; %</span>
                    </mat-form-field>
                </div>
                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Periodo de actualización</mat-label>
                        <mat-select formControlName="periodoActualizacion">
                            <mat-option *ngFor="let period of updatePeriods" [value]="period.codigo">
                                {{ period.descripcion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Plazo</mat-label>
                        <input matInput formControlName="duracion" type="number">
                        <mat-error *ngIf="quoteFG.controls.duracion.hasError('required')">
                            Por favor ingrese el plazo
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Datos del solicitante -->
                <p class="form-section-label">Datos del solicitante (opcional)</p>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Nombre</mat-label>
                        <input matInput formControlName="nombre" type="text">
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Apellido</mat-label>
                        <input matInput formControlName="apellido" type="text">
                    </mat-form-field>
                </div>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>DNI / CUIT</mat-label>
                        <input matInput formControlName="dniCuit" type="text">
                    </mat-form-field>
                    <mat-checkbox class="garantor-checkbox" formControlName="perfilAprobado" color="primary">
                        Perfil aprobado
                    </mat-checkbox>
                </div>

                <div class="form-line">
                    <mat-checkbox class="garantor-checkbox" formControlName="incluir12Cuotas" color="primary">
                        Incluir 12 cuotas en el PDF
                    </mat-checkbox>
                </div>
        </div>
        <button mat-raised-button color="accent" class="garantor-button quote-button" [disabled]="!quoteFG.valid">Cotizar</button>
    </form>
    <div class="quote-result-tab" *ngIf="quoteResult">
        <span class="dialog-title">
            Resultado de su cotización
        </span>
        <span class="dialog-description">
            Estas son las opciones disponibles para su garantía.
        </span>
        <app-quote-result [quote]="quoteResult" #quoteResultRef></app-quote-result>
        <div class="services-section">
            <!-- Deshabilitado temporalmente: los servicios ya se muestran en la grilla de app-quote-result
            <app-data-printer class="services-printer" [categories]="serviceCategories"></app-data-printer>
            -->
            <!-- Deshabilitado temporalmente: no se debe mostrar la comisión de Garantor por el momento
            <span class="commission">
                Comisión Remax: <b>$ {{ utilsService.beautifyNumber(commission ? commission.total : 0, 2) }}</b>
            </span>
            <span class="commission">
                Comisión para pago financiado: <b>$ {{ utilsService.beautifyNumber(commission ? commission.totalFinanciado : 0, 2) }}</b>
            </span>
            -->
            <div class="result-buttons">
                <span class="action-link" *ngIf="quoteResult?.id" (click)="quoteResultRef.openSendByEmailDialog()">
                    <mat-icon>send</mat-icon>
                    <span>Enviar por email</span>
                </span>
                <span class="action-link pdf-link" *ngIf="quoteResult?.id" (click)="quoteResultRef.downloadPdf()">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span>Generar PDF</span>
                </span>
                <button mat-raised-button color="accent" type="button" class="garantor-button restart-button" (click)="reset()">Volver a cotizar</button>
                <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="verCotizacion()">Ver cotización</button>
            </div>
        </div>
    </div>
</div>
